import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'
import { STORE_MAP } from '@/config/cache/cache-engine'

export default {
	getAvailablePartners: {
		useCache: true, //кешируемый флаг
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.PARTNERS].GET_AVAILABLE_PARTNERS,
	},
	getBasedPartners: {
		useCache: true,
		cacheStorage: STORE_MAP.BASE,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.PARTNERS].GET_AVAILABLE_PARTNERS,
	},
	getExtendedPartners: {
		useCache: true,
		cacheStorage: STORE_MAP.EXTENDED,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.PARTNERS].GET_AVAILABLE_PARTNERS,
	},
	getFullPartners: {
		useCache: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.PARTNERS].GET_AVAILABLE_PARTNERS,
	},
}
